import styled from "styled-components";

// Constants
import { Dropdown } from "components/spocketUI";

// Utils
import { media } from "utils/media";

export const LanguagesWrapper = styled.div``;

export const LanguagesList = styled(Dropdown)`
  .dropdown {
    margin-top: 10px;
    padding: 14px 16px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.12);

    ${media.TABLET`
      margin-top: 8px;
    `};
  }

  .dropdown button {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    color: ${props => props.theme.colors.black.colorBlack300};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
    padding: 0;
    height: 19px;

    &:hover {
      cursor: pointer;
      background-color: ${props =>
        props.theme.colors.addOpacity({ color: props.theme.colors.purple.colorPurple15, opacity: 0.1 })};
    }
  }
`;

export const Trigger = styled.div`
  background: ${props => props.theme.colors.white.colorWhite};
  border: solid 1px
    ${props => props.theme.colors.addOpacity({ color: props.theme.colors.black.colorBlack300, opacity: 0.2 })};

  box-sizing: border-box;
  border-radius: 71px;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: max-content;
  cursor: pointer;
  width: 100%;
  gap: 8px;

  ${media.TABLET`
    padding: 10px 16px;
  `};
`;

export const LanguageContainer = styled.div`
  text-align: center;
  display: flex;
  gap: 4px;
`;

export const LanguageText = styled.p`
  font-size: 14px;
  text-align: center;
  color: ${props => props.theme.colors.black.colorBlack300};
  margin-bottom: 0;
  font-weight: 800;
  line-height: normal;
`;

export const LanguageSymbol = styled(LanguageText)`
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
`;

export const LanguageSelected = styled.span`
  color: ${props => props.theme.colors.purple.colorPurple15};

  text-align: center;
  font-family: Avenir;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const LanguageSelectedContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const LanguageFlagContainer = styled.div`
  width: 16px;
  height: 16px;
`;

export const SymbolLanguageSelected = styled(LanguageSelected)`
  text-transform: uppercase;
`;

export const TriggerIcon = styled.img``;
